module.exports = __webpack_public_path__ + "static/media/escape-the-pack.9a580f5f.svg";